import React, { useEffect } from 'react';
import useScroll from '../../../../hooks/scroll-hook';
import useSideDrawer from '../../../../hooks/side-drawer-hook';
import useHasMounted from '../../../../hooks/client-only-hook';
import './layout.scss';
import BG from '../../ui-elements/bg/particles/particles';
import SideDrawer from '../side-drawer/side-drawer';
import Header from '../header/header';
import NavLinks from '../nav-links/nav-links';
import Language from '../language/language';
import Burger from '../burger/burger';
import Footer from '../footer/footer';
import SNS from '../sns/sns';
import Brand from '../brand/brand';
import Copyright from '../../ui-elements/copyright/copyright';

var Layout = function Layout(_ref) {
  var _mq;

  var children = _ref.children,
      pathname = _ref.pathname;

  // Hooks
  var _useScroll = useScroll(),
      isShow = _useScroll.isShow,
      setIsShow = _useScroll.setIsShow,
      scrollDownHideUpShow = _useScroll.scrollDownHideUpShow;

  var _useSideDrawer = useSideDrawer(),
      drawerIsOpen = _useSideDrawer.drawerIsOpen,
      openDrawerHandler = _useSideDrawer.openDrawerHandler,
      closeDrawerHandler = _useSideDrawer.closeDrawerHandler;

  scrollDownHideUpShow(); // Show header when re-rendering happens

  useEffect(function () {
    setIsShow(false);
  }, []);
  var mq;
  var hasMounted = useHasMounted();

  if (hasMounted) {
    mq = window.matchMedia('(max-width: 37.5em)');
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BG, null), ((_mq = mq) === null || _mq === void 0 ? void 0 : _mq.matches) && /*#__PURE__*/React.createElement(Brand, {
    place: "layout",
    className: isShow ? 'hide--mobile' : ''
  }), /*#__PURE__*/React.createElement(Burger, {
    onClick: openDrawerHandler,
    isOpen: drawerIsOpen,
    className: isShow ? 'hide--mobile' : ''
  }), /*#__PURE__*/React.createElement(SideDrawer, {
    show: drawerIsOpen,
    onCancel: closeDrawerHandler
  }, /*#__PURE__*/React.createElement("nav", {
    className: "side-drawer__nav"
  }, /*#__PURE__*/React.createElement(NavLinks, {
    place: "side-drawer"
  }), /*#__PURE__*/React.createElement(SNS, {
    width: 20,
    height: 20,
    place: "side-drawer"
  })), /*#__PURE__*/React.createElement("div", {
    className: "side-drawer__footer"
  }, /*#__PURE__*/React.createElement(Language, {
    place: "side-drawer",
    path: pathname
  }), /*#__PURE__*/React.createElement(Copyright, {
    place: "side-drawer"
  }))), /*#__PURE__*/React.createElement(Header, {
    className: isShow ? 'hide' : ''
  }, /*#__PURE__*/React.createElement(Brand, {
    place: "header"
  }), /*#__PURE__*/React.createElement("nav", {
    className: "header__nav"
  }, /*#__PURE__*/React.createElement(NavLinks, {
    place: "header"
  }), /*#__PURE__*/React.createElement(Language, {
    place: "header",
    path: pathname
  }))), /*#__PURE__*/React.createElement("main", {
    className: "layout__main"
  }, children), /*#__PURE__*/React.createElement(Footer, null, /*#__PURE__*/React.createElement("div", {
    className: "footer__left-wrapper"
  }, /*#__PURE__*/React.createElement(Copyright, {
    place: "footer"
  })), /*#__PURE__*/React.createElement("div", {
    className: "footer__right-wrapper"
  }, /*#__PURE__*/React.createElement(SNS, {
    width: 20,
    height: 20,
    place: "footer"
  }))));
};

export default Layout;